/* eslint-disable  prettier/prettier */
/**
 * This file contains system wide configs
 *
 * @since 0.1.0
 * @version 0.1.0
 */
import React from 'react';
import map from 'lodash/map';
import Cookies from 'js-cookie';
import moment from 'moment';

export const ConfigsContext = React.createContext();
export const RolesContext = React.createContext();
export const AppContext = React.createContext();
export const LocaleContext = React.createContext();

export const DATE_FORMAT = 'dd-MM-yyyy';

export const DATE_TIME_FORMAT = 'YYYY-MM-DD hh:mm a';

export const DATE_FORMAT_DOB = 'YYYY-MM-DD';

export const SCHEDULE_SMS_DATE_FORMAT = 'yyyy-M-dd hh:mm a';

export const THEME = '';

export const TITLE_OPTIONS = [
  { value: 'Mr.', label: 'Mr. ' },
  { value: 'Mrs.', label: 'Mrs. ' },
  { value: 'Ms.', label: 'Ms. ' },
];

export const SCHEME_OPTIONS = [
  { value: 'reseller', label: 'Reseller' },
  { value: 'vendor', label: 'Vendor' },
];

export const DELETE_OPTIONS = [
  { value: 'selected', label: 'Delete Selected ' },
  { value: 'all', label: 'Delete All' },
];

export const GENDER = {
  male: 'Male',
  female: 'Female',
};

export const VENDOR_TYPES = {
  1: 'Individual',
  2: 'Organization',
};

export const VENDOR_TYPE = [
  { value: 'Individual', label: 'No' },
  { value: 'Organization', label: 'Yes' },
];

export const API_TYPES = {
  1: 'Active',
  0: 'Inactive',
};

export const TWOWAY_STATUS = {
  1: 'Active',
  0: 'Inactive',
};

export const SIZE_TYPES = [
  { value: '1-10', label: '1-10' },
  { value: '10-100', label: '10-100' },
  { value: '100-500', label: '100-500' },
  { value: '500-1000', label: '500-1000' },
  { value: '1000-above', label: '1000-above' },
];

export const ORGANIZATION = [
  { value: 'Advertising', label: 'Advertising' },
  { value: 'Agriculture', label: 'Agriculture' },
  { value: 'Business Services', label: 'Business Services' },
  {
    value: 'Manufacturing & Consumer Goods',
    label: 'Manufacturing & Consumer Goods',
  },
  { value: 'Consumer Services', label: 'Consumer Services' },
  { value: 'Financial Services', label: 'Financial Services' },
  { value: 'Government', label: 'Government' },
  { value: 'Hospitality', label: 'Hospitality' },
  { value: 'Health Care', label: 'Health Care' },
  { value: 'Logistics & Transport', label: 'Logistics & Transport' },
  { value: 'Media', label: 'Media' },
  { value: 'Religious Organizations', label: 'Religious Organizations' },
  { value: 'Retail', label: 'Retail' },
  { value: 'Technology', label: 'Technology' },
  { value: 'Trading or Distribution', label: 'Trading or Distribution' },
  { value: 'Others', label: 'Others' },
];

export const ROLE_OPTIONS = [
  { value: 'Sales', label: 'Sales' },
  { value: 'Marketing', label: 'Marketing' },
  { value: 'Operations', label: 'Operations' },
  { value: 'Technology', label: 'Technology' },
  { value: 'Management', label: 'Management' },
  { value: 'Other', label: 'Other' },
];

export const GOAL_OPTIONS = [
  {
    value: 'Keep in Touch with Current Customers',
    label: 'Keep in Touch with Current Customers',
  },
  { value: 'Reward Current Customers', label: 'Reward Current Customers' },
  {
    value: 'Understand or survey your current customers',
    label: 'Understand or survey your current customers',
  },
  { value: 'Reach New Customers', label: 'Reach New Customers' },
  { value: 'Verify Customer Identity', label: 'Verify Customer Identity' },
  {
    value: 'Interact or present information to customers',
    label: 'Interact or present information to customers',
  },
  { value: 'Verify Customer Identity', label: 'Verify Customer Identity' },
  {
    value: 'Collect or send payments to customers',
    label: 'Collect or send payments to customers',
  },
  {
    value: 'Reduce cost to support/sell to customers',
    label: 'Reduce cost to support/sell to customers',
  },
  {
    value: 'To Integrate API or services in my project',
    label: 'To Integrate API or services in my project',
  },
  {
    value: 'Others',
    label: 'Others',
  },
];

export const VENDOR_SMS_REMINDER = {
  0: 'Inactive',
  1: 'Active',
};

export const LIMIT_FILTERS = {
  50: {
    en: '50 Records Limit',
    fr: 'Limite de 50 enregistrements',
    sw: 'Ishia rekodi 50',
  },
  1000: {
    en: '1000 Records Limit',
    fr: 'Limite de 1000 enregistrements',
    sw: 'Ishia rekodi 1000',
  },
  10000: {
    en: '10k Records Limit',
    fr: 'Limite de 10k enregistrements',
    sw: 'Ishia rekodi 10k',
  },
  50000: {
    en: '50k Records Limit',
    fr: 'Limite de 50k enregistrements',
    sw: 'Ishia rekodi 50k',
  },
  all: {
    en: 'All',
    fr: 'All',
    sw: 'Rudisha zote',
  },
};

export const USER_ROLES = {
  vendor: 'Vendor',
  admin: 'Admin',
  reseller: 'Reseller',
  subaccount: 'Sub-Account',
  accounts: 'Admin Accounts',
  technical: 'Admin Technical',
  sales: 'Sales',
  support: 'Admin Support',
  senderid: 'Admin Sender Id',
  salesadmin: 'Admin Sales',
};

export const VENDOR_ACCOUNT_STATUSES = VENDOR_SMS_REMINDER;

/* used in sender names */
export const STATUSES = {
  pending: 'Pending',
  active: 'Active',
  inactive: 'InActive',
};

export const NETWORK_STATUS = {
  0: 'Active',
  1: 'Inactive',
};
export const PURCHASE_STATUSES = {
  allocated: 'Allocated',
  pending: 'Pending',
  rejected: 'Rejected',
};

export const BILLING_TYPE = {
  toll_free: 'Toll Free',
  premium: 'Premium',
  standard: 'Standard',
};

export const BILLING_TYPE_OPTIONS = map(BILLING_TYPE, (value, key) => ({
  value: key,
  label: value,
}));

export const CODE_TYPE = {
  shared: 'Shared',
  dedicated: 'Dedicated',
};

export const CODE_TYPE_OPTIONS = map(CODE_TYPE, (value, key) => ({
  value: key,
  label: value,
}));

export const NUMBER_TYPE = {
  longcode: 'Long Code',
  shortcode: 'Short Code',
};

export const NUMBER_TYPE_OPTIONS = map(NUMBER_TYPE, (value, key) => ({
  value: key,
  label: value,
}));

export const ALLOCATE_OPTIONS = {
  add: 'Add Credit',
  deduct: 'Deduct Credit',
};

export const SMS_STATUSES = ['DELIVERED', 'PENDING', 'EXPIRED', 'UNDELIVERED'];

export const PURCHASE_PAYMENT_STATUSES = {
  0: 'Not Paid',
  1: 'Paid',
  2: 'Partially Paid',
  3: 'Receipt Sent',
  4: 'Bonus',
};

export const SORT_DAYS = {
  7: '7 days',
  14: '14 days',
  30: '1 month',
  90: '3 months',
  180: '6 months',
};

export const PAYMENT_STATUSES = {
  0: 'Pending',
  1: 'Processed',
  2: 'Over Paid',
  3: 'Under Paid',
};

export const REQUEST_MAIN_STATUSES = {
  0: 'GET',
  1: 'POST',
  2: 'PATCH',
  3: 'DELETE',
};

export const REQUEST_STATUSES = map(REQUEST_MAIN_STATUSES, (value, key) => ({
  value: key,
  label: value,
}));

export const REPORT_DURATION_OLD = [
  { value: 'day', name: { en: 'This Day', fr: 'Ce jour', sw: 'Leo' } },
  {
    value: 'week',
    name: { en: 'This Week', fr: 'Cette semaine', sw: 'Wiki hii' },
  },
  {
    value: 'month',
    name: { en: 'This Month', fr: 'Ce mois', sw: 'Mwezi huu' },
  },
  {
    value: 'year',
    name: { en: 'This Year', fr: 'Cette année', sw: 'Mwaka huu' },
  },
];

export const REPORT_DURATIONS = [
  { value: 'day', name: 'Day' },
  { value: 'week', name: 'Week' },
  { value: 'month', name: 'Month' },
];

export const MESSAGE_STATUS = [
  { value: 'all', name: 'All' },
  { value: 'read', name: 'Read' },
  { value: 'delivered', name: 'Delivered' },
  { value: 'failed', name: 'Failed' },
];

export const DURATION_OPTIONS = map(REPORT_DURATIONS, (duration) => ({
  value: duration.value,
  label: duration.name,
}));
export const OVERVIEW_REPORT_DURATIONS = [
  {
    value: 'days',
    label: {
      en: 'By days per month',
      fr: 'Par jours par mois',
      sw: 'kwa siku kwa Mwezi',
    },
  },
  {
    value: 'custom',
    label: {
      en: 'By days per month per year',
      fr: 'Par jours par mois par an',
      sw: 'Kwa mwezi kwa mwaka',
    },
  },
  {
    value: 'months',
    label: {
      en: 'By months per year',
      fr: 'Par jours par an',
      sw: 'kwa siku kwa mwaka',
    },
  },
];

export const MONTHS = [
  { name: 'January', value: 1 },
  { name: 'February', value: 2 },
  { name: 'March', value: 3 },
  { name: 'April', value: 4 },
  { name: 'May', value: 5 },
  { name: 'June', value: 6 },
  { name: 'July', value: 7 },
  { name: 'August', value: 8 },
  { name: 'September', value: 9 },
  { name: 'October', value: 10 },
  { name: 'November', value: 11 },
  { name: 'December', value: 12 },
];

export const MONTHS_OPTIONS = map(MONTHS, (month) => ({
  value: month.value,
  label: month.name,
}));

export const CONTACT_SCHEMA = {
  Phone: 'mob_no',
  AdditionalPhone: 'mob_no2',
  Title: 'title',
  FirstName: 'fname',
  LastName: 'lname',
  Gender: 'gender',
  DOB: 'birth_date',
  Address: 'address',
  Area: 'area',
  City: 'city',
  Country: 'country',
  Email: 'email',
};

export const DEFAULT_BROADCAST_CACHE = {
  groups: [],
  includedContacts: [],
  excludedContact: [],
  additionalContacts: [],
  smsTemplate: null,
  message: '',
  scheduleDate: undefined,
  mobileNumbers: [],
  recipientColumn: null,
  file: null,
  fileContent: [],
  hasHeader: true,
};

export const DEFAULT_CONTACTS_CACHE = {
  file: null,
  fileContent: [],
  groups: [],
  hasHeader: true,
};

export const PURCHASE_PAYMENT_STATUS_OPTIONS = map(
  PURCHASE_PAYMENT_STATUSES,
  (value, key) => ({
    value: key,
    label: value,
  })
);

export const SORT_DAYS_OPTIONS = map(SORT_DAYS, (value, key) => ({
  value: key,
  label: value,
}));

export const PURCHASE_STATUS_OPTIONS = map(PURCHASE_STATUSES, (value, key) => ({
  value: key,
  label: value,
}));

export const ALLOCATE_STATUS_OPTIONS = map(ALLOCATE_OPTIONS, (value, key) => ({
  value: key,
  label: value,
}));

export const PAYMENT_STATUS_OPTIONS = map(PAYMENT_STATUSES, (value, key) => ({
  value: key,
  label: value,
}));

export const LIMIT_FILTER_OPTIONS = map(LIMIT_FILTERS, (value, key) => ({
  value: key,
  label: value,
}));

export const EMG_USE_CASE = [
  {
    value: 'transactional',
    label: 'Transactional',
  },
  {
    value: 'promotional',
    label: 'Promotional',
  },
  {
    value: 'promotional',
    label: 'Transactional & Promotional',
  },
];

export const PURCHASE_STATUS_TOPUP = {
  allocated: 'Allocated',
  pending: 'Pending',
  rejected: 'Rejected',
};

export const PURCHASE_STATUS_TOPUP_OPTIONS = map(
  PURCHASE_STATUS_TOPUP,
  (value, key) => ({
    value: key,
    label: value,
  })
);

export const PAYMENT_METHOD_TYPES = {
  collections: 'Collections',
  push: 'Checkout',
};

export const WHITELISTEDAPPS = {
  WHATSAPPBROADCAST: 'u0ZKqEuDUHWQ',
  SMARTROUTING: 'sGBssnOcgr',
  YEASTAR: 'gHEVdatXTn',
  REWARDS: 'KYhiyg3Emu',
  SURVEYS: 'oTbG20VQEX',
  ECOMMERCE: 'iyg3Emhiy',
  BOOKINGS: 'KYhiiyg3Em',
};

export const LANGUAGES = [
  { label: 'Afrikaans', value: 'af' },
  { label: 'Albanian', value: 'sq' },
  { label: 'Arabic', value: 'ar' },
  { label: 'Azerbaijani', value: 'az' },
  { label: 'Bengali', value: 'bn' },
  { label: 'Bulgarian', value: 'bg' },
  { label: 'Catalan', value: 'ca' },
  { label: 'Chinese (CHN)', value: 'zh_CN' },
  { label: 'Chinese (HKG)', value: 'zh_HK' },
  { label: 'Chinese (TAI)', value: 'zh_TW' },
  { label: 'Croatian', value: 'hr' },
  { label: 'Czech', value: 'cs' },
  { label: 'Danish', value: 'da' },
  { label: 'Dutch', value: 'nl' },
  { label: 'English', value: 'en' },
  { label: 'English (UK)', value: 'en_GB' },
  { label: 'English (US)', value: 'en_US' },
  { label: 'Estonian', value: 'et' },
  { label: 'Filipino', value: 'fil' },
  { label: 'Finnish', value: 'fi' },
  { label: 'French', value: 'fr' },
  { label: 'Georgian', value: 'ka' },
  { label: 'German', value: 'de' },
  { label: 'Greek', value: 'el' },
  { label: 'Gujarati', value: 'gu' },
  { label: 'Hausa', value: 'ha' },
  { label: 'Hebrew', value: 'he' },
  { label: 'Hindi', value: 'hi' },
  { label: 'Hungarian', value: 'hu' },
  { label: 'Indonesian', value: 'id' },
  { label: 'Irish', value: 'ga' },
  { label: 'Italian', value: 'it' },
  { label: 'Japanese', value: 'ja' },
  { label: 'Kannada', value: 'kn' },
  { label: 'Kazakh', value: 'kk' },
  { label: 'Kinyarwanda', value: 'rw_RW' },
  { label: 'Korean', value: 'ko' },
  { label: 'Kyrgyz (Kyrgyzstan)', value: 'ky_KG' },
  { label: 'Lao', value: 'lo' },
  { label: 'Latvian', value: 'lv' },
  { label: 'Lithuanian', value: 'lt' },
  { label: 'Macedonian', value: 'mk' },
  { label: 'Malay', value: 'ms' },
  { label: 'Malayalam', value: 'ml' },
  { label: 'Marathi', value: 'mr' },
  { label: 'Norwegian', value: 'nb' },
  { label: 'Persian', value: 'fa' },
  { label: 'Polish', value: 'pl' },
  { label: 'Portuguese (BR)', value: 'pt_BR' },
  { label: 'Portuguese (POR)', value: 'pt_PT' },
  { label: 'Punjabi', value: 'pa' },
  { label: 'Romanian', value: 'ro' },
  { label: 'Russian', value: 'ru' },
  { label: 'Serbian', value: 'sr' },
  { label: 'Slovak', value: 'sk' },
  { label: 'Slovenian', value: 'sl' },
  { label: 'Spanish', value: 'es' },
  { label: 'Spanish (ARG)', value: 'es_AR' },
  { label: 'Spanish (SPA)', value: 'es_ES' },
  { label: 'Spanish (MEX)', value: 'es_MX' },
  { label: 'Swahili', value: 'sw' },
  { label: 'Swedish', value: 'sv' },
  { label: 'Tamil', value: 'ta' },
  { label: 'Telugu', value: 'te' },
  { label: 'Thai', value: 'th' },
  { label: 'Turkish', value: 'tr' },
  { label: 'Ukrainian', value: 'uk' },
  { label: 'Urdu', value: 'ur' },
  { label: 'Uzbek', value: 'uz' },
  { label: 'Vietnamese', value: 'vi' },
  { label: 'Zulu', value: 'zu' },
];

export const DEFAULT_RATES_CACHE = {
  file: null,
  fileContent: [],
  hasHeader: true,
  mappedColumns: {},
};

export const TEST_SENDER = [
  {
    value: 'BEEM',
    label: 'BEEM',
  },
];

export const createMonthOptions = () => [
  { value: '*', label: 'Every Month' },
  ...[
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ].map((month, index) => ({
    label: month,
    value: String(index + 1),
  })),
];

export const createDayOptions = (max, allLabel) => [
  { value: '*', label: allLabel },
  ...Array.from({ length: max }, (_, i) => ({
    value: String(i + 1),
    label: String(i + 1),
  })),
];

export const createWeekdayOptions = () => [
  { value: '*', label: 'Every Day Of The Week' },
  ...[
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ].map((day, index) => ({
    value: String(index),
    label: day,
  })),
];

export const stepDescription = ({ botSettings }) => {
  const isYeastar = botSettings?.connector === 'Yeastar';

  return {
    whatsapp: [
      {
        step: 1,
        title: '1. Request For Channel',
        description:
          '- We have received your request for a new chat setup. Our team will contact you shortly to begin the onboarding process.',
      },
      {
        step: 2,
        title: '2. Verify Facebook Business Account',
        description: `
      - In order to proceed, you need to follow the steps highlighted in the guide <a href="https://drive.google.com/file/d/1s3EovoeSB9rWxx75k66cyACWN8cEOshZ/view">here</a> and contact us at <a href "mailto:support@beem.africa">support@beem.africa</a>.<br/>
      - Required documents<br/>
      <ol type="i">
      <li>Business registration ( or any legal document that mentions the business name)</li>
      <li>Tax Registration, utility bill or bank statement ( any legal document that has the business address including the phone number)</li>`,
      },
      {
        step: 3,
        title: '3. WhatsApp Business Account Verification',
        description:
          '- Your verification request has been submitted. You will receive an email notification once approved.',
      },
      {
        step: 4,
        title: '4. Facebook Security Verification',
        description: `We will need to link your Facebook & WhatsApp account and authorize API access for our platform.
      - In order to proceed, you need to follow the steps highlighted in the guide <a href="https://drive.google.com/file/d/1s3EovoeSB9rWxx75k66cyACWN8cEOshZ/view">here</a> and contact us at <a href "mailto:support@beem.africa">support@beem.africa</a>.`,
      },
      {
        step: 5,
        title: '5. WhatsApp Business Account Setup',
        description:
          '- We are working on setting up your WhatsApp Business Account. This may take a few days. You will receive an email notification once completed.',
      },
      {
        step: 6,
        title: '6. WhatsApp Number Verification',
        description:
          '- You will be receiving a call from our team and an OTP message on the WhatsApp Number for final verification.',
      },
      {
        step: 7,
        title: '7. Moja Number Setup',
        description: `- Congratulations! You're on the final stage, and we are connecting Moja with your WhatsApp number.`,
      },
      {
        step: 8,
        title: '8. Complete',
        description:
          '- Your channel has been successfully set up. For support, contact our support team by chatting with them <a href="https://drive.google.com/file/d/1s3EovoeSB9rWxx75k66cyACWN8cEOshZ/view">here</a> or send an email to <a href "mailto:support@beem.africa">support@beem.africa</a>.',
      },
    ],
    facebook: [
      {
        step: 1,
        title: '1. Request For Channel',
        description:
          '- We have received your request for a new chat setup. Our team will contact you shortly to begin the onboarding process.',
      },
      {
        step: 2,
        title: '2. Verify Facebook Business Account',
        description: `
      - In order to proceed, you need to follow the steps highlighted in the guide <a href="https://drive.google.com/file/d/1s3EovoeSB9rWxx75k66cyACWN8cEOshZ/view">here</a> and contact us at <a href "mailto:support@beem.africa">support@beem.africa</a>.<br/>
      - Required documents<br/>
      <ol type="i">
      <li>Business registration ( or any legal document that mentions the business name)</li>
      <li>Tax Registration, utility bill or bank statement ( any legal document that has the business address including the phone number)</li>`,
      },
      {
        step: 3,
        title: '3. Create Facebook App On Developer Account',
        description:
          '- You will need to create a Facebook App for Beem to be able to connect your account to your Facebook page. In order to proceed, you need to follow the steps highlighted in the guide <a href="https://drive.google.com/file/d/1s3EovoeSB9rWxx75k66cyACWN8cEOshZ/view">here</a> and contact us at <a href "mailto:support@beem.africa">support@beem.africa</a>.',
      },
      {
        step: 4,
        title: '4. Moja Facebook Account Setup',
        description:
          '- We will contact you to get the App ID & Secret Token from the App you created to connect the Facebook App with Moja.',
      },
      {
        step: 5,
        title: '5. Submit App For Review',
        description:
          '- Submit your Facebook App for review by following the guide and contact our support team to walk you through the process.',
      },
      {
        step: 6,
        title: '6. Complete',
        description:
          '- Your channel has been successfully set up. For support, contact our support team by chatting with them <a href="https://drive.google.com/file/d/1s3EovoeSB9rWxx75k66cyACWN8cEOshZ/view">here</a> or send an email to <a href "mailto:support@beem.africa">support@beem.africa</a>.',
      },
    ],
    instagram: [
      {
        step: 1,
        title: 'step 1',
        description: '<br/>verify instagram',
      },
      {
        step: 2,
        title: 'step 2',
        description: '<br/>verify instagram',
      },
      {
        step: 3,
        title: 'step 3',
        description: '<br/>verify instagram',
      },
      {
        step: 4,
        title: 'step 4',
        description: '<br/>verify instagram',
      },
    ],
    sms: [
      {
        step: 1,
        title: '1. Request For Channel',
        description:
          '- We have received your request for a new chat setup. Our team will contact you shortly to begin the onboarding process.',
      },
      {
        step: 2,
        title: '2. Validation',
        description:
          "- We would like to give you an update on your two-way SMS request validation. We have managed to submit your request and it is in the pending approval process with the Mobile Network Operators. The process may take 10-14 days. You'll receive an email update from us when it is complete.",
      },
      {
        step: 3,
        title: '3. Setup',
        description:
          '- We are in the final steps of your two-way SMS setup. We are activating your number in the countries you have selected.',
      },
      {
        step: 4,
        title: '4. Complete',
        description: `- You are now ready to send and receive SMS messages on Moja. Kindly fill in the fields below with your API key and secret key which can be found <a href ='${
          process.env.REACT_APP_ENGAGE_URL
        }/?token=${Cookies.get(
          'token'
        )}' target="_blank">here</a> under <strong>API SETUP</strong>`,
      },
    ],
    google_business_messaging: [
      {
        step: 1,
        title: '1. Create Google Business Messages',
        description:
          '- To get started please create a <strong>Business Messages</strong> partner account then create & verify an agent.Follow the link<a href = https://business-communications.cloud.google.com/console/partner-console><strong> here.<strong></a>',
      },
      {
        step: 2,
        title: '2. Connect Google Business Messages',
        description:
          '- Submit your <strong>agent ID & brand ID</strong>. It is accessible on the agent page.',
      },
      {
        step: 3,
        title: '3. Authorization',
        description:
          '- Generate key file from the link <a href=https://business-communications.cloud.google.com/console/partner-console/partner/service-account> <strong>here</strong></a> and upload the file by clicking the button below.',
      },
      {
        step: 4,
        title: '4. Verify Connection',
        description:
          '- Copy the link and paste it in the webhook section of the integrations page, which is accessible on the agents page.&nbsp<strong><p>https://apichatcore.beem.africa/v1/chat</p></strong>',
      },
      {
        step: 5,
        title: '5. Setup Complete',
        description:
          '- Congratulations you have successfully completed the setup connect Moja to your google business messages',
      },
    ],
    voice_call: isYeastar
      ? [
          {
            step: 1,
            title: '1. Request For Yeastar Channel',
            description:
              '- We have received your request. Our team will contact you shortly.',
          },
          {
            step: 2,
            title: '2. Configure Yeastar Settings',
            description: `
          - Copy your **Callback URL**: <br/>
            <code>${process.env.REACT_APP_BEEM_API_URL}chat/${botSettings.metadata.yeastar_callback_id}</code><br/><br/>
          - Log in to your Yeastar PBX and navigate to **Webhook Settings**.<br/>
          - Paste the callback URL in the webhook URL field.<br/>
          - Subscribe to the following event codes:<br/>
            • 30009 – Extension Presence State Changed<br/>
            • 30011 – Call State Changed<br/>
            • 30012 – Call End Details Notifications<br/>
            • 30016 – Incoming Call Request<br/><br/>
          - Use the **Send Test Message** button in Yeastar to verify the connection. A successful test confirms your PBX is correctly linked.
        `,
          },
          {
            step: 3,
            title: '3. Complete',
            description: '- Your Yeastar integration is now active.',
          },
        ]
      : [
          // if voice_call but NOT Yeastar
          // {
          //   step: 1,
          //   title: '1. Voice Call Setup',
          //   description:
          //     '- We have received your request for a voice call channel.',
          // },
          // {
          //   step: 2,
          //   title: '2. Verification',
          //   description: '- Our team will verify the phone number provided.',
          // },
          // {
          //   step: 3,
          //   title: '3. Complete',
          //   description: '- Your voice call channel is now active.',
          // },
        ],
  };
};

export const formatDateUTC = (date, date_format = DATE_TIME_FORMAT) => {
  return moment.utc(date).format(date_format);
};

export const CHANNELS = [
  { label: 'Whatsapp', value: 'whatsapp' },
  { label: 'Facebook', value: 'facebook' },
  { label: 'Sms', value: 'sms' },
  { label: 'Instagram', value: 'instagram' },
  { label: 'Voice', value: 'voice_call' },
];

export const DIRECTIONS = [
  {
    label: 'Inbound',
    value: 'inbound',
  },
  { label: 'Outbound', value: 'outbound' },
];
